import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toSentence' })
export class ToSentencePipe implements PipeTransform {
  private _convertToText(inCamelCaseString) {
    const result = inCamelCaseString
      .replace(/(_)+/g, ' ')
      .replace(/([a-z])([A-Z][a-z])/g, '$1 $2')
      .replace(/([A-Z][a-z])([A-Z])/g, '$1 $2')
      .replace(/([a-z])([A-Z]+[a-z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z][a-z])/g, '$1 $2')
      .replace(/([a-z]+)([A-Z0-9]+)/g, '$1 $2')

      .replace(/([A-Z]+)([A-Z][a-rt-z][a-z]*)/g, '$1 $2')
      .replace(/([0-9])([A-Z][a-z]+)/g, '$1 $2')

      .replace(/([A-Z]{2,})([0-9]{2,})/g, '$1 $2')
      .replace(/([0-9]{2,})([A-Z]{2,})/g, '$1 $2')
      .trim();
    // capitalize the first letter
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
  transform(value: string): any {
    if (typeof value === 'undefined' || value === null || value === undefined) {
      return value;
    }
    return this._convertToText(value);
  }
}
